module.exports = __webpack_public_path__ + "img/logo-black-01.7fa83a6c.svg";